import { some } from 'lodash';
import { Observable, Subject, takeUntil } from 'rxjs';

import {
  GameTimerEnum,
  QuestActivityType,
  RemunerationDtoType,
  LoyaltySettingsType,
  QuestActionDefinitionDefinitionGamePuzzleThresholdType,
} from '@sifca-monorepo/widget-generator';
import { defineElement } from '@lordicon/element';
import { ChangeDetectorRef, Component, EventEmitter, OnInit, Output } from '@angular/core';

import { reputationPicture } from '../../../../environments/environment';
import { ImageService, MobileQuestsService, MobileReputationService, MobileThemeService, RouteChangeService, TimeBlockLimitationService as TimeService } from '@sifca-monorepo/clients';

@Component({
  template: '',
})
export class MobileAppSlidingComponent implements OnInit {
  private unsubscribeAll: Subject<any> = new Subject<any>();

  @Output() argsUpdate = new EventEmitter<any>();
  @Output() performActivity = new EventEmitter<any>();

  timer: number;
  timeLeft: number;
  hasAmount = true;
  darkMode: boolean;
  skipDisplay: boolean;
  puzzleDisplay = false;
  questActivities: QuestActivityType[];
  reputationPicture = reputationPicture;
  selectedQuestActivity: QuestActivityType;
  thresholds: QuestActionDefinitionDefinitionGamePuzzleThresholdType[];
  loyaltySettings$: Observable<LoyaltySettingsType> = this.reputationService.loyaltySettings$;

  constructor(
    protected cd: ChangeDetectorRef,
    protected timeService: TimeService,
    protected imageService: ImageService,
    protected themeService: MobileThemeService,
    protected questsService: MobileQuestsService,
    protected routeChangeService: RouteChangeService,
    protected reputationService: MobileReputationService,
  ) {}

  ngOnInit(): void {
    defineElement();
    this.questsService.questActivitesByQuest$.pipe(takeUntil(this.unsubscribeAll)).subscribe((questActivitesByQuest) => {
      this.questActivities = questActivitesByQuest;
    });
    this.questsService.selectedQuestActivity$.pipe(takeUntil(this.unsubscribeAll)).subscribe((questActivity) => {
      this.selectedQuestActivity = questActivity;
      this.thresholds = this.selectedQuestActivity?.activity?.action?.definition?.game?.sliding?.threshold;
      this.hasAmount = some(this.thresholds, (item) => some(item.bonus, (data: RemunerationDtoType) => data?.amount));
      if (this.thresholds?.length > 0 && this.hasAmount) {
        this.skipDisplay = true;
      }
      if (this.thresholds?.length === 1 && !this.hasAmount) {
        this.timer =
          this.selectedQuestActivity?.activity?.action?.definition?.game?.sliding?.threshold[0]?.timer === GameTimerEnum.FIVE_MINUTES
            ? 300
            : this.selectedQuestActivity?.activity?.action?.definition?.game?.sliding?.threshold[0]?.timer === GameTimerEnum.HALF_MINUTE
              ? 30
              : this.selectedQuestActivity?.activity?.action?.definition?.game?.sliding?.threshold[0]?.timer === GameTimerEnum?.MINUTE
                ? 60
                : this.selectedQuestActivity?.activity?.action?.definition?.game?.sliding?.threshold[0]?.timer === GameTimerEnum?.TWO_MINUTES
                  ? 120
                  : null;
        this.puzzleDisplay = true;
        this.timeLeft = this.timer;
        this.timeService.setTimeLeft(this.timer);
      } else if (!this.thresholds?.length) {
        this.timer = null;
        this.puzzleDisplay = true;
        this.hasAmount = false;
      }
    });
    this.themeService.darkMode$.pipe(takeUntil(this.unsubscribeAll)).subscribe((darkMode) => {
      this.darkMode = darkMode;
      this.cd.detectChanges();
    });
    this.routeChangeService.setRoute();
  }

  skip() {
    this.puzzleDisplay = true;
    this.timer = null;
    this.cd.markForCheck();
  }

  perform(game) {
    this.performActivity.emit(game);
  }

  onArgsUpdate(game) {
    this.argsUpdate.emit(game);
  }

  loadImage(event: any) {
    let file: File = event.target.files[0];
    if (file) {
      let reader = new FileReader();
      reader.onload = (ev) => {
        let imgSrc = ev.target!.result as string;
        this.imageService.setPuzzleImgSrc(imgSrc);
      };
      reader.readAsDataURL(file);
    }
  }

  startGame(timeLeft: number): void {
    this.timer = timeLeft;
    this.timeLeft = timeLeft;
    this.timeService.setTimeLeft(timeLeft);
    this.puzzleDisplay = true;
    this.cd.markForCheck();
  }

  onPuzzleDisplayChange(display: boolean): void {
    this.puzzleDisplay = display;
  }

  ngOnDestroy(): void {
    this.unsubscribeAll.next(true);
    this.unsubscribeAll.complete();
  }
}
